import { PublicPricingPlan } from '../../types/employer/PublicPricingPlan';

const URL = '/v2/public/pricing-plans';

class PublicPricingPlanService {
  static async findAll(): Promise<PublicPricingPlan[]> {
    const response = await fetch(URL, { credentials: 'omit' });

    if (!response.ok) {
      throw new Error(`Request failed with status ${response.status}`);
    }

    return response.json();
  }
}

export { PublicPricingPlanService };
